import MapaGoogleGeneral from "./Components/MapaGeneralGoogle/MapaGoogleGeneral";
import MapaInteractivo from "./Pantallas_Finales/MapaInteractivo";
import AdmonImages from "./Components/AdmonImages";

export const rutas = [
    { ruta: '/mapa', component: <MapaInteractivo /> },
    { ruta: '/admonImages', component: <AdmonImages /> },
];